export default "/institutions/pagaleve.svg";